import React from "react";
import { Navigate } from "react-router-dom";
import { hasRight } from "../utils/userRights";

const ProtectedRoute = ({ formName, action = "view", children }) => {
  // check if user has required right
  const allowed = hasRight(formName, action);

  if (!allowed) {
    // redirect if no rights
    return <Navigate to="/unauthorized" replace />;
  }

  return children;
};

export default ProtectedRoute;




// const ProtectedRoute = ({ children, formName, action }) => {
//   const userRights = JSON.parse(sessionStorage.getItem("userRights") || "[]");

//   // Use lowercase comparison for safety
//   const hasPermission = userRights.some(
//     (r) => r.formName.toLowerCase() === formName.toLowerCase() && r[`can${action.charAt(0).toUpperCase() + action.slice(1)}`]
//   );

//   if (!hasPermission) {
//     return <Navigate to="/login" replace />;
//   }

//   return children;
// };


// export default ProtectedRoute;